export default function(data, element) {
  var self = this;
  self.$el = $(element);
  self.institution = ko.observable();
  self.saving = ko.observable(false);
  self.dummyBool = ko.observable(true); //used to force computed observable to update
  self.serverErrors = ko.observableArray();
  self.clientErrors = ko.observableArray();
  self.uploading = ko.observable(false);
  self.countries = ko.observableArray();
  self.states = ko.observableArray();

  self.defaultNoticeOptions = {
    parentObject: '.instructor-edit--sidebar',
    method: 'append'
  };

  self.available_categories = ko.observableArray(['Academic', 'Arts & Culture', 'Creative Education', 'Industry', 'Publishers', 'Promotional']);

  self.savedAtText = ko.computed(function() {
    self.dummyBool();
    if (self.saving()) {
      return Kadenze.I18n.t('dict.saving');
    }
    else if (self.institution && self.institution() && self.institution().updated_at()) {
      return Kadenze.I18n.t('dict.last_saved_at') + ' ' + moment(self.institution().updated_at()).fromNow();
    }
    else {
      return '';
    }
  });

  self.initUI = function() {
    self.initStateCountrySelect();
    self.initLogoDropzone();
  };

  self.initStateCountrySelect = function() {
    var _callback = function (data, status, jqXHR) {
      self.countries(data.countries);
      self.states(data.states);
    };

    self.institution().address.country.subscribe(function(country) {
      $(document).click(); //Hack to get selectpicker to hide
      Kadenze.Util.fetchLocationData({country: country}, _callback);
    });

    self.institution().address.state.subscribe(function(state) {
      $(document).click(); //Hack to get selectpicker to hide
    });

    // Kadenze.Util.fetchLocationData({}, _callback);
  };

  self.initLogoDropzone = function() {
    var $els = $('.js-institution-img-dz', self.$el);

    $els.each(function(idx, el) {
      var $el = $(el);
      if (!el.dropzone) {
        var $imageInput = $('.js-institution-img-path', $el.parent());
        var $removeInput = $('.js-institution-img-remove', $el.parent());
        var institutionDZ;

        var name = $el.data('dz-name') + '_path';
        var fileObj = {
          path: self.institution()[name]()
        };

        $el.addClass('dz-unit');

        var msgText = 'Add Logo';

        var message = JST['templates/dropzone-standard-message']({
          title: msgText,
          optional: 'Accepted Types: SVG'
        });
        message = Kadenze.I18n.tt(message, 'en');

        var uploadURL = Kadenze.Routes.temp_image_upload_path();


        var callbacks = {
          thumbnail: function (file, data) { },
          sending: function (file, xhr, formData) { },
          success: function (file, response) {
            var name = $el.data('dz-name') + '_path';
            if (response.path.match(/^https?/)) {
              name = 'remote_' + $el.data('dz-name') + '_url';
            }
            self.institution()[name](response.path);
            name = 'remove_' + $el.data('dz-name');
            self.institution()[name](false);
          },
          error: function (file, errorMessage) {},
          complete: function (file) {},
          addedfile: function (file) {},
          removedfile: function (file) {
            var name = $el.data('dz-name') + '_path';
            self.institution()[name]('');
            name = 'remove_' + $el.data('dz-name');
            self.institution()[name](true);
          }
        };

        var opts = {acceptedFiles: '.svg'};

        institutionDZ = new Kadenze.ImageDropZone($el, message, uploadURL, callbacks, fileObj, opts);
      }
    });
  };



  self.save = function() {
    self.serverErrors();
    var url = Kadenze.Routes.admin_institutions_path();
    var method = 'POST';
    if (self.institution().id()) {
      url = Kadenze.Routes.admin_institution_path(self.institution().id());
      method = 'PATCH';
    }
    var request = null;
    var data = {'institution': ko.mapping.toJS(self.institution) };
    data.institution.address_attributes = data.institution.address;
    delete data.institution.address;

    if (self.validate()) {
      request = $.ajax({
        type: method,
        url: url,
        data: data,
        dataType: 'json',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        },
        beforeSend: function(xhr, settings) {
          self.saving(true);
        },
        success: function(data, textStatus, xhr) {
          ko.mapping.fromJSON(data.institution, self.institution());

          new Kadenze.Notice.success($.extend({}, self.defaultNoticeOptions, { message: Kadenze.I18n.t('dict.publish_success') }));
        },
        error: function(xhr, textStatus, errorThrown) {
          console.log(errorThrown);
          new Kadenze.Notice.error($.extend({}, self.defaultNoticeOptions, { message: xhr.responseJSON.message }));
        },
        complete: function(xhr, textStatus) {
          self.saving(false);
        }
      });
    }

    return request;
  };

  self.validate = function() {
    self.clientErrors = ko.validation.group(self.institution, { deep: true });
    if (self.clientErrors().length === 0 || (self.clientErrors().length === 1 && self.clientErrors()[0] === null)) {
      return true;
    } else {
      self.clientErrors.showAllMessages();
      return false;
    }
  };

  self.bindData = function(data) {
    if (typeof data === 'string') {
      data = JSON.parse(data);
    }
    self.countries(data.countries);
    self.states(data.states);
    var inst_data = _.extend(data.institution, {remove_logo: false, remove_alt_logo: false, remove_alt_logo_2: false, remote_logo_url: null, remote_alt_logo_url: null, remote_alt_logo_2_url: null} );
    // self.countries(data.countries);
    // self.states(data.states);
    self.institution(ko.mapping.fromJS(inst_data));
  };

  const __construct = function(that) {
    console.log('constructor called for AdminInstitutionEditViewModel');
    that.bindData(data);
  }(this);

  return self;
}

